import ApexCharts from 'apexcharts'

const championshipGraphs = (gsap, $container) => {
	
	const $championshipGraph = $container.find("#championshipGraph");
	const $championshipGraph1Mobile = $container.find("#championshipGraph1Mobile");
	const $championshipGraph2Mobile = $container.find("#championshipGraph2Mobile");
	
	const series1 = [
		{
			name: 'Main networks',
			data: [
				{
					x: ['Norfolk State', 'vs. Florida', ' ', '(3/21)'],
					y: 135000,
					day: 'Fri',
					time: '6:42P',
					network: 'TNT'
				},
				{
					x: ['Uconn vs. ', 'Florida', ' ', '(3/23)'],
					y: 399000,
					day: 'Sun',
					time: '12N',
					network: 'CBS'
				},
				{
					x: ['Maryland vs.', 'Florida', ' ', '(3/27)'],
					y: 191000,
					day: 'Thur',
					time: '7:31P',
					network: 'TBS'
				},
				{
					x: ['Texas Tech', 'vs. Florida', ' ', '(3/29)'],
					y: 257000,
					day: 'Sat',
					time: '6P',
					network: 'TBS'
				},
				{
					x: ['Auburn vs.', 'Florida', ' ', '(4/5)'],
					y: 672000,
					day: 'Sat',
					time: '5:57P',
					network: 'CBS'
				},
				{
					x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
					y: 896000,
					day: 'Mon',
					time: '8:43P',
					network: 'CBS'
				}
			]
		},
		{
			name: 'Other networks',
			data: [
				{
					x: ['Norfolk State', 'vs. Florida', ' ', '(3/21)'],
					y: 0,
					day: 'Fri',
					time: '6:42P',
					network: 'TNT'
				},
				{
					x: ['Uconn vs. ', 'Florida', ' ', '(3/23)'],
					y: 0,
					day: 'Sun',
					time: '12N',
					network: 'CBS'
				},
				{
					x: ['Maryland vs.', 'Florida', ' ', '(3/27)'],
					y: 74000,
					day: 'Thur',
					time: '7:31P',
					network: 'TBS'
				},
				{
					x: ['Texas Tech', 'vs. Florida', ' ', '(3/29)'],
					y: 97000,
					day: 'Sat',
					time: '6P',
					network: 'TBS'
				},
				{
					x: ['Auburn vs.', 'Florida', ' ', '(4/5)'],
					y: 0,
					day: 'Sat',
					time: '5:57P',
					network: 'CBS'
				},
				{
					x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
					y: 0,
					day: 'Mon',
					time: '8:43P',
					network: 'CBS'
				}
			]
		}
	];
	
	//const series2 = [
	//	{
	//		name: 'Main networks',
	//		data: [
	//			{
	//				x: ['Houston', 'vs. Florida', ' ', '(4/7)'],
	//				y: 1268000,
	//				day: 'Mon',
	//				time: '8:43P',
	//				network: 'CBS'
	//			},
	//			{
	//				x: ['Duke vs.', 'Houston', ' ', '(4/5)'],
	//				y: 868000,
	//				day: 'Sat',
	//				time: '9:17P',
	//				network: 'CBS'
	//			},
	//			{
	//				x: ['Tennessee', 'vs. Houston', ' ', '(3/30)'],
	//				y: 505000,
	//				day: 'Sun',
	//				time: '2:11P',
	//				network: 'CBS'
	//			},
	//			{
	//				x: ['Purdue vs.', 'Houston', ' ', '(3/28)'],
	//				y: 231000,
	//				day: 'Fri',
	//				time: '10:01P',
	//				network: 'TBS'
	//			},
	//			{
	//				x: ['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
	//				y: 255000,
	//				day: 'Sat',
	//				time: '8:32P',
	//				network: 'TNT'
	//			},
	//			{
	//				x: ['SIUE vs.', 'Houston', ' ', '(3/20)'],
	//				y: 63000,
	//				day: 'Thur',
	//				time: '1:49P',
	//				network: 'TBS'
	//			}
	//		]
	//	},
	//	{
	//		name: 'Other networks',
	//		data: [
	//			{
	//				x: ['Houston', 'vs. Florida', ' ', '(4/7)'],
	//				y: 0,
	//				day: 'Mon',
	//				time: '8:43P',
	//				network: 'CBS'
	//			},
	//			{
	//				x: ['Duke vs.', 'Houston', ' ', '(4/5)'],
	//				y: 0,
	//				day: 'Sat',
	//				time: '9:17P',
	//				network: 'CBS'
	//			},
	//			{
	//				x: ['Tennessee', 'vs. Houston', ' ', '(3/30)'],
	//				y: 0,
	//				day: 'Sun',
	//				time: '2:11P',
	//				network: 'CBS'
	//			},
	//			{
	//				x: ['Purdue vs.', 'Houston', ' ', '(3/28)'],
	//				y: 58000,
	//				day: 'Fri',
	//				time: '10:01P',
	//				network: 'TruTV'
	//			},
	//			{
	//				x: ['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
	//				y: 0,
	//				day: 'Sat',
	//				time: '8:32P',
	//				network: 'TNT'
	//			},
	//			{
	//				x: ['SIUE vs.', 'Houston', ' ', '(3/20)'],
	//				y: 0,
	//				day: 'Thur',
	//				time: '1:49P',
	//				network: 'TBS'
	//			}
	//		]
	//	},
	//];

	const series2mobile = [
		{
			name: 'Main networks',
			data: [
				{
					x: ['SIUE vs.', 'Houston', ' ', '(3/20)'],
					y: 63000,
					day: 'Thur',
					time: '1:49P',
					network: 'TBS'
				},
				{
					x: ['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
					y: 255000,
					day: 'Sat',
					time: '8:32P',
					network: 'TNT'
				},
				{
					x: ['Purdue vs.', 'Houston', ' ', '(3/28)'],
					y: 231000,
					day: 'Fri',
					time: '10:01P',
					network: 'TBS'
				},
				{
					x: ['Tennessee', 'vs. Houston', ' ', '(3/30)'],
					y: 505000,
					day: 'Sun',
					time: '2:11P',
					network: 'CBS'
				},
				{
					x: ['Duke vs.', 'Houston', ' ', '(4/5)'],
					y: 868000,
					day: 'Sat',
					time: '9:17P',
					network: 'CBS'
				},
				{
					x: ['Houston', 'vs. Florida', ' ', '(4/7)'],
					y: 1268000,
					day: 'Mon',
					time: '8:43P',
					network: 'CBS'
				},
			]
		},
		{
			name: 'Other networks',
			data: [
				{
					x: ['Houston', 'vs. Florida', ' ', '(4/7)'],
					y: 0,
					day: 'Mon',
					time: '8:43P',
					network: 'CBS'
				},
				{
					x: ['Duke vs.', 'Houston', ' ', '(4/5)'],
					y: 0,
					day: 'Sat',
					time: '9:17P',
					network: 'CBS'
				},
				{
					x: ['Tennessee', 'vs. Houston', ' ', '(3/30)'],
					y: 0,
					day: 'Sun',
					time: '2:11P',
					network: 'CBS'
				},
				{
					x: ['Purdue vs.', 'Houston', ' ', '(3/28)'],
					y: 58000,
					day: 'Fri',
					time: '10:01P',
					network: 'TruTV'
				},
				{
					x: ['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
					y: 0,
					day: 'Sat',
					time: '8:32P',
					network: 'TNT'
				},
				{
					x: ['SIUE vs.', 'Houston', ' ', '(3/20)'],
					y: 0,
					day: 'Thur',
					time: '1:49P',
					network: 'TBS'
				}
			]
		},
	];
			
	const xLabels1 = [
		['Norfolk State', 'vs. Florida', ' ', '(3/21)'], 
		['Uconn vs.', 'Florida', ' ', '(3/23)'],
		['Maryland vs.', 'Florida', ' ', '(3/27)'],
		['Texas Tech', 'vs. Florida', ' ', '(3/29)'],
		['Auburn vs.', 'Florida', ' ', '(4/5)'],
		['Houston vs.', 'Florida', ' ', '(4/7)']
	];
	
	const xLabels1mobile = [
		['Norfolk State vs.', ' Florida (3/21)'], 
		['Uconn vs. Florida', '(3/23)'],
		['Maryland vs.', 'Florida (3/27)'],
		['Texas Tech vs.', 'Florida (3/29)'],
		['Auburn vs. Florida', '(4/5)'],
		['Houston vs.', 'Florida (4/7)']
	];
	
	//const xLabels2 = [
	//	['Houston', 'vs. Florida', ' ', '(4/7)'],
	//	['Duke vs.', 'Houston', ' ', '(4/5)'],
	//	['Tennessee', 'vs. Houston', ' ', '(3/30)'],
	//	['Purdue vs.', 'Houston', ' ', '(3/28)'],
	//	['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
	//	['SIUE vs.', 'Houston', ' ', '(3/20)'],
	//];
	
	//const xLabels2mobile = [
	//	['Houston vs.', 'Florida (4/7)'],
	//	['Duke vs.', 'Houston (4/5)'],
	//	['Tennessee', 'vs. Houston (3/30)'],
	//	['Purdue vs.', 'Houston (3/28)'],
	//	['Gonzaga vs.', 'Houston (3/22)'],
		
	//];
	
	const xLabels3 = [
		['SIUE vs.', 'Houston', ' ', '(3/20)'],
		['Houston', 'vs. Florida', ' ', '(4/7)'],
		['Duke vs.', 'Houston', ' ', '(4/5)'],
		['Tennessee', 'vs. Houston', ' ', '(3/30)'],
		['Purdue vs.', 'Houston', ' ', '(3/28)'],
		['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
	];
	
	const xLabels3mobile = [
		['SIUE vs. Houston', '(3/20)'],
		['Gonzaga vs.', 'Houston (3/22)'],
		['Purdue vs.', 'Houston (3/28)'],
		['Tennessee', 'vs. Houston (3/30)'],
		['Duke vs. Houston', '(4/5)'],
		['Houston vs.', 'Florida (4/7)'],
	];
	
	const series1Colors = ['#0BBCD4', '#B6F3FB'];
	const series2Colors = ['#8E66EB', '#C6B2F5'];
		
	function renderLegend(context) {
		const chartItem = $(context.el);
		const chartBox = chartItem.find('.apexcharts-inner');
		const bbox = chartBox.get(0).getBoundingClientRect();
		const width = bbox.width - 10;
		const firstChild = chartBox.firstChild;

		const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
		foreignObject.setAttribute('width', width); // Set width and height for the foreignObject
		foreignObject.setAttribute('height', 20);
		foreignObject.setAttribute('x', 5);
		foreignObject.setAttribute('y', 0);

		var htmlDiv = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
		htmlDiv.innerHTML = '<div class="round-legend"><span>Round 1</span><span class="polygon"></span><span>Round 2</span><span class="polygon"></span><span>Round 3</span><span class="polygon"></span><span>Round 4</span><span class="polygon"></span><span>Round 5</span><span class="polygon"></span><span>Round 6</span></div>'; // Add HTML content

		foreignObject.appendChild(htmlDiv);
		chartBox.get(0).insertBefore(foreignObject, firstChild);
	}
	
	function renderDoubleLegend(context) {
		const chartItem = $(context.el);
		const chartBox = chartItem.find('.apexcharts-inner');
		const bbox = chartBox.get(0).getBoundingClientRect();
		const width = bbox.width - 10;
		const firstChild = chartBox.firstChild;

		const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
		foreignObject.setAttribute('width', width); // Set width and height for the foreignObject
		foreignObject.setAttribute('height', 20);
		foreignObject.setAttribute('x', 5);
		foreignObject.setAttribute('y', 0);

		var htmlDiv = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
		htmlDiv.innerHTML = '<div class="round-double-legend"><div><span>Round 1</span><span class="polygon"></span><span>Round 2</span><span class="polygon"></span><span>Round 3</span><span class="polygon"></span><span>Round 4</span><span class="polygon"></span><span>Round 5</span><span class="polygon"></span><span>Round 6</span></div><div><span>Round 1</span><span class="polygon"></span><span>Round 2</span><span class="polygon"></span><span>Round 3</span><span class="polygon"></span><span>Round 4</span><span class="polygon"></span><span>Round 5</span><span class="polygon"></span><span>Round 6</span></div></div>'; // Add HTML content

		foreignObject.appendChild(htmlDiv);
		chartBox.get(0).insertBefore(foreignObject, firstChild);
	}
	
	function wrapTitle(context) {
		const chartItem = $(context.el);
		const titleBox = $container.find('.championship-pill');
		const container = chartItem.find('.apexcharts-series');
		const containerWidth = container.get(0).getBoundingClientRect().width;
		const containerLeft = chartItem.find('.apexcharts-yaxis').get(0).getBoundingClientRect().width;
		
		titleBox.css({
			width: containerWidth,
			left: containerLeft + (containerWidth * .0145),
		});
	
	}
		
	function createMobileGraph(item, series, xLabels, xLabelsMobile, colors) {
		if (!item || !item.isConnected) return null;
		
		try {
			var options = {
				series: series,
				colors: colors,
				fill: {
					opacity: 1,
				},
				chart: {
					type: 'bar',
					stacked: true,
					fontFamily: 'Aeonik',
					width: '100%',
					height: '100%',
					parentHeightOffset: 0,
					toolbar: {
						show: false,
					},
					animations: {
						animateGradually: {
							enabled: true,
							delay: 500
						}
					},
					events: {
						mounted: function(chartContext) {
							renderLegend(chartContext);
						},
						updated: function(chartContext) {
							renderLegend(chartContext);
						}
					}
				},
				grid: {
					borderColor: 'rgba(255, 255, 255, 0.2)',
					padding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
					},
					xaxis: {
						lines: {
							show: false,
						}
					},
				},
				dataLabels: {
					offsetY: 2,
					style: {
						fontSize: '13px',
						fontWeight: 700,
						colors: [function(opts) { return '#121212' }]
					},
					formatter: function (value) {
						return value.toLocaleString();
					},
				},
				xaxis: {
					type: 'category',
					categories: xLabels,
					axisTicks: {
						show: false,
					},
					labels: {
						rotate: 0,
						maxHeight: undefined,
						offsetY: 0,
						style: {
							fontFamily: 'Aeonik',
							colors: 'rgba(255, 255, 255, 1)'
						},
					}
				},
				yaxis: {
					max: 1500000,
					stepSize: 500000,
					labels: {
						maxWidth: 63,
						align: 'left',
						style: {
							fontSize: '14px',
							fontFamily: 'Aeonik',
							colors: 'rgba(255, 255, 255, 0.5)',
						},
						formatter: function(value) {
							return value.toLocaleString();
						}
					},
				},
				states: {
					hover: {
						filter: {
							type: 'none',
						}
					},
					active: {
						filter: {
							type: 'none',
						}
					}
				},
				tooltip: {
					enabled: true,
					shared: false,
					followCursor: false,
					custom: function({ w, series, seriesIndex, dataPointIndex }) {
						if ( seriesIndex === 3 || seriesIndex === 1 ) {
							return `
								<div class="recap-donut-tooltip">
									<p class="text-center p-legal">
										Simulcast game <br>
										(played on two <br>
										networks at the <br>
										same time).
									</p>
								</div>
							`;
						} else {
							// 1) Grab our data‐object for this bar:
							const dataObj = w.config.series[seriesIndex].data[dataPointIndex];
							// 2) Extract the numeric `y`:
							const yValue = dataObj.y;
							// 3) Calculate "sum of all series at this index":
							const totalAtPoint = w.globals.stackedSeriesTotals[dataPointIndex];
							const pct = ((yValue / totalAtPoint) * 100).toFixed(0);
							// 4) Pull your hidden fields out of dataObj:
							const day   = dataObj.day;
							const time  = dataObj.time;
							const net   = dataObj.network;
							// 5) Build whatever HTML you like:
							return `
								<div class="recap-donut-tooltip">
									<div>Day of week: <strong>${day}</strong></div>
									<div>Start time: <strong>${time}</strong></div>
									<div>Network: <strong>${net}</strong></div>
								</div>
							`;
						}
					}
				},
				responsive: [{
					breakpoint: 1300,
					chart: {
						width: "100%",
						height: "auto",
					},
					options: {
						dataLabels: {
							style: {
								fontSize: '9px',
								fontWeight: 700,
								colors: [function(opts) { return '#121212' }]
							}
						},
						xaxis: {
							categories: xLabelsMobile,
							labels: {
								rotate: -90,
								offsetY: -5,
								style: {
									fontSize: '12px',
									fontFamily: 'Aeonik',
									colors: 'rgba(255, 255, 255, 1)'
								},
							}
						},
						yaxis: {
							max: 1500000,
							stepSize: 500000,
							labels: {
								maxWidth: 40,
								align: 'left',
								offsetX: -5,
								style: {
									fontSize: '8px',
									colors: 'rgba(255, 255, 255, 0.5)',
								},
								formatter: function(value) {
									return value.toLocaleString();
								}
							},
						}
					},
				}],
				plotOptions: {
					area: {
						fillTo: 'origin',
					},
					bar: {
						horizontal: false,
						columnWidth: '95%',
						colors: {
							backgroundBarColors: [
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
							],
						},
						dataLabels: {
							total: {
								enabled: true,
								style: {
									fontSize: '14px',
									fontWeight: 700,
									color: '#fff'
								},
								offsetY: -10,
								formatter: function(value) {
									const totalViewers = 8151180;
									const pct = Math.round((value / totalViewers) * 100);
									return `${pct}%`;
								}
							}
						}
					},
				},
				legend: {
					show: false,
				},
			};
			
			return new ApexCharts(item, options);
		} catch (error) {
			console.warn('Failed to create mobile graph:', error);
			return null;
		}
	}
	
	function renderSplitDataChart(containerSelector) {
		if (!containerSelector || !containerSelector.isConnected) return null;
		
		try {
			var options = {
				series: [
					{
						name: 'Floridian households watching',
						color: "#0BBCD4",
						data: [
							{
								x: ['Norfolk State', 'vs. Florida', ' ', '(3/21)'],
								y: 135000,
								day: 'Fri',
								time: '6:42P',
								network: 'TNT'
							},
							{
								x: ['Uconn vs. ', 'Florida', ' ', '(3/23)'],
								y: 399000,
								day: 'Sun',
								time: '12N',
								network: 'CBS'
							},
							{
								x: ['Maryland vs.', 'Florida', ' ', '(3/27)'],
								y: 191000,
								day: 'Thur',
								time: '7:31P',
								network: 'TBS'
							},
							{
								x: ['Texas Tech', 'vs. Florida', ' ', '(3/29)'],
								y: 257000,
								day: 'Sat',
								time: '6P',
								network: 'TBS'
							},
							{
								x: ['Auburn vs.', 'Florida', ' ', '(4/5)'],
								y: 672000,
								day: 'Sat',
								time: '5:57P',
								network: 'CBS'
							},
							{
								x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
								y: 896000,
								day: 'Mon',
								time: '8:43P',
								network: 'CBS'
							},
							{
								x: ' ',
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Duke vs.', 'Houston', ' ', '(4/5)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Tennessee', 'vs. Houston', ' ', '(3/30)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Purdue vs.', 'Houston', ' ', '(3/28)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['SIUE vs.', 'Houston', ' ', '(3/20)'],
								y: null,
								day: null,
								time: null,
								network: null
							}
						]
					},
					{
						name: 'Florida games simulcast',
						color: "#B6F3FB",
						data: [
							{
								x: ['Norfolk State', 'vs. Florida', ' ', '(3/21)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Uconn vs. ', 'Florida', ' ', '(3/23)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Maryland vs.', 'Florida', ' ', '(3/27)'],
								y: 74000,
								day: 'Thur',
								time: '7:31P',
								network: 'TruTV'
							},
							{
								x: ['Texas Tech', 'vs. Florida', ' ', '(3/29)'],
								y: 97000,
								day: 'Sat',
								time: '6P',
								network: 'TruTV'
							},
							{
								x: ['Auburn vs.', 'Florida', ' ', '(4/5)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ' ',
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Duke vs.', 'Houston', ' ', '(4/5)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Tennessee', 'vs. Houston', ' ', '(3/30)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Purdue vs.', 'Houston', ' ', '(3/28)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['SIUE vs.', 'Houston', ' ', '(3/20)'],
								y: null,
								day: null,
								time: null,
								network: null
							}
						]
					},
					{
						name: 'Texan households watching',
						color: "#8E66EB",
						data: [
							{
								x: ['Norfolk State', 'vs. Florida', ' ', '(3/21)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Uconn vs. ', 'Florida', ' ', '(3/23)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Maryland vs.', 'Florida', ' ', '(3/27)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Texas Tech', 'vs. Florida', ' ', '(3/29)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Auburn vs.', 'Florida', ' ', '(4/5)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ' ',
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
								y: 1268000,
								day: 'Mon',
								time: '8:43P',
								network: 'CBS'
							},
							{
								x: ['Duke vs.', 'Houston', ' ', '(4/5)'],
								y: 868000,
								day: 'Sat',
								time: '9:17P',
								network: 'CBS'
							},
							{
								x: ['Tennessee', 'vs. Houston', ' ', '(3/30)'],
								y: 505000,
								day: 'Sun',
								time: '2:11P',
								network: 'CBS'
							},
							{
								x: ['Purdue vs.', 'Houston', ' ', '(3/28)'],
								y: 231000,
								day: 'Fri',
								time: '10:01P',
								network: 'TBS'
							},
							{
								x: ['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
								y: 255000,
								day: 'Sat',
								time: '8:32P',
								network: 'TNT'
							},
							{
								x: ['SIUE vs.', 'Houston', ' ', '(3/20)'],
								y: 63000,
								day: 'Thur',
								time: '1:49P',
								network: 'TBS'
							}
						]
					},
					{
						name: 'Texas games simulcast',
						color: "#C6B2F5",
						data: [
							{
								x: ['Norfolk State', 'vs. Florida', ' ', '(3/21)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Uconn vs. ', 'Florida', ' ', '(3/23)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Maryland vs.', 'Florida', ' ', '(3/27)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Texas Tech', 'vs. Florida', ' ', '(3/29)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Auburn vs.', 'Florida', ' ', '(4/5)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ' ',
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Houston vs.', 'Florida', ' ', '(4/7)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Duke vs.', 'Houston', ' ', '(4/5)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Tennessee', 'vs. Houston', ' ', '(3/30)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['Purdue vs.', 'Houston', ' ', '(3/28)'],
								y: 58000,
								day: 'Fri',
								time: '10:01P',
								network: 'TruTV'
							},
							{
								x: ['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
								y: null,
								day: null,
								time: null,
								network: null
							},
							{
								x: ['SIUE vs.', 'Houston', ' ', '(3/20)'],
								y: null,
								day: null,
								time: null,
								network: null
							}
						]
					}
				],
				fill: {
					opacity: 1,
				},
				chart: {
					type: 'bar',
					stacked: true,
					fontFamily: 'Aeonik',
					width: '100%',
					height: '100%',
					parentHeightOffset: 0,
					toolbar: {
						show: false,
					},
					animations: {
						animateGradually: {
							enabled: true,
							delay: 2000
						}
					},
					events: {
						mounted: function(chartContext) {
							renderDoubleLegend(chartContext);
							wrapTitle(chartContext);
						},
						updated: function(chartContext) {
							renderDoubleLegend(chartContext);
							wrapTitle(chartContext);
						}
					}
				},
				grid: {
					borderColor: 'rgba(255, 255, 255, 0)',
					padding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
					},
					xaxis: {
						lines: {
							show: false,
						}
					},
				},
				dataLabels: {
					offsetY: 2,
					style: {
						fontSize: '13px',
						fontWeight: 700,
						colors: [function(opts) { return '#121212' }]
					},
					formatter: function (value) {
						if ( typeof value === 'number' && !isNaN(value) ) {
							return value.toLocaleString();
						} else {
							return '';
						}
					},
				},
				xaxis: {
					type: 'category',
					categories: [
						['Norfolk State', 'vs. Florida', ' ', '(3/21)'],
						['UConn vs. ', 'Florida', ' ', '(3/23)'],
						['Maryland vs.', 'Florida', ' ', '(3/27)'],
						['Texas Tech', 'vs. Florida', ' ', '(3/29)'],
						['Auburn vs.', 'Florida', ' ', '(4/5)'],
						['Houston vs.', 'Florida', ' ', '(4/7)'],
						' ',
						['Houston vs.', 'Florida', ' ', '(4/7)'],
						['Duke vs.', 'Houston', ' ', '(4/5)'],
						['Tennessee', 'vs. Houston', ' ', '(3/30)'],
						['Purdue vs.', 'Houston', ' ', '(3/28)'],
						['Gonzaga vs.', 'Houston', ' ', '(3/22)'],
						['SIUE vs.', 'Houston', ' ', '(3/20)']
					],
					axisTicks: {
						show: false,
					},
					labels: {
						rotate: 0,
						maxHeight: undefined,
						offsetY: 0,
						style: {
							fontSize: '12px',
							fontFamily: 'Aeonik',
							colors: 'rgba(255, 255, 255, 1)'
						},
					}
				},
				yaxis: {
					max: 1800000,
					stepSize: 500000,
					labels: {
						offsetX: 0,
						style: {
							fontSize: '14px',
							fontFamily: 'Aeonik',
							colors: 'rgba(255, 255, 255, 0.5)',
							paddingRight: 10,
						},
						formatter: function(value) {
							if (value % 500000 === 0) {
								return value.toLocaleString() + '\xa0\xa0\xa0\xa0';
							} else {
								return '';
							}
						}
					},
				},
				states: {
					hover: {
						filter: {
							type: 'none',
						}
					},
					active: {
						filter: {
							type: 'none',
						}
					}
				},
				colors: [['#0BBCD4', '#B6F3FB'], ['#8E66EB', '#C6B2F5']],
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '95%',
						colors: {
							backgroundBarColors: [
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
								'rgba(0, 0, 0, 0)',
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
								'rgba(255, 255, 255, 0.03)',
								'rgba(255, 255, 255, 0.05)',
							],
						},
						dataLabels: {
							total: {
								enabled: true,
								style: {
									fontSize: '14px',
									fontWeight: 700,
									color: '#fff'
								},
								offsetY: -10,
								formatter: function(value, opts) {
									let totalViewers = '';
									if (opts.SeriesIndex === 0 || opts.SeriesIndex === 2) {
										totalViewers = 8151180;
									} else {
										totalViewers = 9763385;
									}
									const pct = Math.round((value / totalViewers) * 100);
									if (pct > 0) {
										return `${pct}%`;
									} else {
										return '';
									}
								}
							}
						}
					},
				},
				legend: {
					show: true,
					horizontalAlign: 'right',
					formatter: function(seriesName, opts) {
						if ( seriesName === 'Floridian households watching' || seriesName === 'Texan households watching' ) {
							return `<div class="legend-item" style="background-color: ${opts.w.globals.seriesColors[opts.seriesIndex]};">
							<div class="legend-item-text">${seriesName}</div>
						</div>`;
						} else {
							return '';
						}
					},
					onItemClick: {
						toggleDataSeries: false
					},
					onItemHover: {
						highlightDataSeries: false
					}
				},
				tooltip: {
					enabled: true,
					shared: false,
					followCursor: false,
					custom: function({ w, series, seriesIndex, dataPointIndex }) {
						if ( seriesIndex === 3 || seriesIndex === 1 ) {
							return `
								<div class="recap-donut-tooltip">
									<p class="text-center p-legal">
										Simulcast game <br>
										(played on two <br>
										networks at the <br>
										same time).
									</p>
								</div>
							`;
						} else {
							// 1) Grab our data‐object for this bar:
							const dataObj = w.config.series[seriesIndex].data[dataPointIndex];
							// 2) Extract the numeric `y`:
							const yValue = dataObj.y;
							// 3) Calculate "sum of all series at this index":
							const totalAtPoint = w.globals.stackedSeriesTotals[dataPointIndex];
							const pct = ((yValue / totalAtPoint) * 100).toFixed(0);
							// 4) Pull your hidden fields out of dataObj:
							const day   = dataObj.day;
							const time  = dataObj.time;
							const net   = dataObj.network;
							// 5) Build whatever HTML you like:
							return `
								<div class="recap-donut-tooltip">
									<div>Day of week: <strong>${day}</strong></div>
									<div>Start time: <strong>${time}</strong></div>
									<div>Network: <strong>${net}</strong></div>
								</div>
							`;
						}
					}
				},
				responsive: [
					{
						breakpoint: 1200,
						options: {
							dataLabels: {
								style: {
									fontSize: '9px',
								},
							},
							xaxis: {
								type: 'category',
								categories: [
									['Norfolk State vs.', 'Florida (3/21)'],
									['UConn vs. Florida', '(3/23)'],
									['Maryland vs.', 'Florida (3/27)'],
									['Texas Tech vs.', 'Florida (3/29)'],
									['Auburn vs. Florida', '(4/5)'],
									['Houston vs.', 'Florida (4/7)'],
									' ',
									['Houston vs.', 'Florida (4/7)'],
									['Duke vs. Houston', '(4/5)'],
									['Tennessee', 'vs. Houston (3/30)'],
									['Purdue vs.', 'Houston (3/28)'],
									['Gonzaga vs.', 'Houston (3/22)'],
									['SIUE vs. Houston', '(3/20)']
								],
								labels: {
									rotate: -90,
									maxHeight: undefined,
									offsetY: 5,
								}
							},
							yaxis: {
								max: 1800000,
								stepSize: 500000,
								labels: {
									offsetX: 0,
									style: {
										fontSize: '12px',
										fontFamily: 'Aeonik',
										colors: 'rgba(255, 255, 255, 0.5)',
										paddingRight: 10,
									},
									formatter: function(value) {
										if (value % 500000 === 0) {
											return value.toLocaleString() + '\xa0\xa0\xa0\xa0';
										} else {
											return '';
										}
									}
								},
							},
							plotOptions: {
								bar: {
									dataLabels: {
										total: {
											enabled: true,
											style: {
												fontSize: '12px',
												fontWeight: 700,
												color: '#fff'
											},
											offsetY: -3,
											formatter: function(value) {
												const totalViewers = 8151180;
												const pct = Math.round((value / totalViewers) * 100);
												if (pct > 0) {
													return `${pct}%`;
												} else {
													return '';
												}
											}
										}
									}
								},
							},
							legend: {
								offsetY: 20,
							}
						}
					}
				]
			};
			
			return new ApexCharts(containerSelector, options);
		} catch (error) {
			console.warn('Failed to create split data chart:', error);
			return null;
		}
	}

	function createIntersectionObserver(element, createChartCallback) {
		if (!element || !element.isConnected) return null;
		
		// Create the chart immediately but don't render it yet
		const chart = createChartCallback();
		if (!chart) return;
		
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// Only render the chart when it comes into view
					chart.render();
					observer.disconnect();
				}
			});
		}, {
			threshold: 1.0,
			rootMargin: "0px 0px 25% 0px"
		});
		
		observer.observe(element);
	}
	
	// Create Intersection Observer for each chart
	if ($championshipGraph1Mobile.length) {
		createIntersectionObserver($championshipGraph1Mobile[0], () => 
			createMobileGraph($championshipGraph1Mobile[0], series1, xLabels1, xLabels1mobile, series1Colors)
		);
	}
	
	if ($championshipGraph2Mobile.length) {
		createIntersectionObserver($championshipGraph2Mobile[0], () => 
			createMobileGraph($championshipGraph2Mobile[0], series2mobile, xLabels3, xLabels3mobile, series2Colors)
		);
	}
	
	if ($championshipGraph.length) {
		createIntersectionObserver($championshipGraph[0], () => 
			renderSplitDataChart($championshipGraph[0])
		);
	}
}

export { championshipGraphs };